'use client'

import React, { useEffect, FC } from 'react';

interface FlutterAppLoaderProps {
  flutterBaseHref: string;
}

const FlutterAppLoader: FC<FlutterAppLoaderProps> = ({ flutterBaseHref }) => {

  useEffect(() => {
    let cancelled = false

    const appendFlutterScript = () => {
      if (cancelled) return

      // Check if the script already exists (e.g., due to fast refresh)
      const existingScript = document.getElementById('flutter-bootstrap-script');
      if (existingScript) {
        console.log('FlutterAppLoader: flutter_bootstrap.js script already exists.');
        return;
      }

      const script = document.createElement('script');
      script.id = 'flutter-bootstrap-script'; // Add an ID for easy checking
      script.src = `${flutterBaseHref}flutter_bootstrap.js`;
      script.async = true;

      script.onload = () => {
        console.log('FlutterAppLoader: flutter_bootstrap.js loaded.');
      };

      script.onerror = () => {
        console.error('FlutterAppLoader: Failed to load flutter_bootstrap.js');
      };

      console.log(`FlutterAppLoader: Appending flutter_bootstrap.js script with src: ${script.src}`);
      document.body.appendChild(script);
    }

    const bridgeReady = (window as any).__yohoFlutterAuthBridgeReady
    Promise.resolve(bridgeReady).finally(appendFlutterScript)

    // Cleanup function to remove the script when the component unmounts
    return () => {
      cancelled = true
      const scriptToRemove = document.getElementById('flutter-bootstrap-script');
      if (scriptToRemove) {
        console.log('FlutterAppLoader: Cleaning up - removing flutter_bootstrap.js script.');
        document.body.removeChild(scriptToRemove);
      }
    };
  }, [flutterBaseHref]); // Dependency array ensures effect runs only if flutterBaseHref changes

  return (
    <>
      {/* Splash Screen HTML - Paths need flutterBaseHref */}
      <picture id="splash">
        <source srcSet={`${flutterBaseHref}splash/img/loading_rocket.png`} media="(prefers-color-scheme: light)" />
        <img className="center" aria-hidden="true" src={`${flutterBaseHref}splash/img/loading_rocket.png`} alt="" style={{ width: '50px' }} />
      </picture>

      {/* Flutter root element */}
      <div id="root"></div>
    </>
  );
};

export default FlutterAppLoader;
